import React, { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import api from "@/lib/api";
import { Sparkle, Loader2 } from "lucide-react";

/**
 * The Curated Gift Wall — a Boutique-tier perk (available to every tier): an ever-refreshing
 * gallery of the Maison's favorite AI-curated card designs for inspiration. Reuses the same
 * public 'Maison Favorites' feed shown on the guest Showroom.
 */
const GiftWall = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/showroom/favorites").then((r) => setItems(r.data.favorites || [])).finally(() => setLoading(false));
  }, []);

  return (
    <AppShell>
      <div className="mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-sm mb-4">
          <Sparkle className="w-4 h-4 gold-text" /> A Boutique Perk
        </div>
        <h1 className="font-serif text-4xl mb-1">The Curated Gift Wall</h1>
        <p className="text-muted-foreground">Fresh inspiration from the Maison&apos;s favorite designs — free for every tier.</p>
      </div>

      {loading ? (
        <div className="text-center py-24 text-muted-foreground flex items-center justify-center gap-2"><Loader2 className="w-5 h-5 animate-spin" /> Loading the wall…</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="gift-wall-grid">
          {items.map((it, i) => (
            <div key={i} className="glass rounded-2xl overflow-hidden card-hover" data-testid="gift-wall-item">
              <img src={`data:image/png;base64,${it.image_base64}`} alt={it.occasion} className="w-full h-48 object-cover" />
              <div className="p-3 text-xs uppercase tracking-wider text-muted-foreground">{it.occasion}</div>
            </div>
          ))}
        </div>
      )}
    </AppShell>
  );
};

export default GiftWall;
